import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createSize,
  fetchAllSizes,
  updateSize,
  fetchOneSize,
  deleteSize,
} from "services/size";

// Fetch all sizes with optional filtering
export const useAllSizes = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["sizes", filters],
    queryFn: () => fetchAllSizes(filters),
    enabled,
  });
};

// Fetch single size by ID
export const useOneSize = (id, enabled = true) => {
  return useQuery({
    queryKey: ["size", id],
    queryFn: () => fetchOneSize(id),
    enabled: Boolean(id) && enabled,
  });
};

// Create new size
export const useCreateSize = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createSize(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sizes"] });
    },
  });
};

// Update existing size
export const useUpdateSize = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateSize({ id, data }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["sizes"] });
      queryClient.invalidateQueries({ queryKey: ["size", variables.id] });
    },
  });
};

// Delete size
export const useDeleteSize = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteSize(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["sizes"] });
      queryClient.invalidateQueries({ queryKey: ["size", id] });
    },
  });
};
